$(document).ready(function () {
	if ($('.login-modal').length){

		var $modal = $('.login-modal');
		var $html = $('html');

		$('.login-modal-toggler').on('click', function (e) {
			e.preventDefault();
			$modal.addClass('open');
			$html.addClass('login-modal-open');
		})

		$('.login-modal .close').on('click', function (e) {
			e.preventDefault();
			$modal.removeClass('open');
			$html.removeClass('login-modal-open');
		})
	}
})


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/login-modal/index.js
 **/